<div class="ui-g">
  <div class="ui-sm-12 ui-md-12 ui-lg-10 ui-xl-8">
      <p-panel header="{{ 'delete_account' | translate }}" [toggleable]="false" [collapsed]="false">
        <p>{{'delete_account_question' | translate}}</p>
        <div class="ui-sm-12 ui-md-6 ui-lg-4 ui-xl-3" style="padding-left: 0; margin-top: 10px;">
          <button pButton type="submit" label="{{ 'delete_account_button' | translate }}" (click)="handleDeleteAccount()" class="ui-button-info"></button>
        </div>
      </p-panel>
  </div>
</div>



